import homepage from './homepage';
import release from './release';
import releaseAction from './release-action';
import settings from './settings';

export const routes = {
  homepage,
  settings,
  release,
  'release-action': releaseAction,
};
